export function setupVersion() {
  if (process.env.IS_CLIENT && process.env.APP_ID && process.env.APP_VERSION) {
    window.appVersions = {
      ...window.appVersions,
      [process.env.APP_ID]: process.env.APP_VERSION,
    };
  }
}
